// extracted by css-extract-rspack-plugin
export default {"error":"CoiDMKjgOEBPsptX"};